import React from "react";
import { ShieldCheck, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FinalCallToAction() {
  return <section data-section-id="252484" id="begin-your-journey" className="bg-background text-foreground py-20 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-secondary/30 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-secondary/30 blur-[120px]" />
      </div>

      <div className="page-container relative z-10 flex flex-col items-center text-center max-w-4xl mx-auto bg-secondary/40 rounded-3xl p-12 md:p-20 shadow-md">
        <div className="inline-flex items-center justify-center p-4 bg-primary/5 rounded-lg mb-8">
          <ShieldCheck className="w-12 h-12 text-primary" />
        </div>

        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold font-default mb-6 leading-tight text-primary">
          Begin Your Journey
        </h2>

        <p className="text-lg md:text-xl font-serif mb-10 text-foreground/90 max-w-2xl mx-auto leading-relaxed">
          Experience the silence. Step into a world of tranquility where every detail is designed for your restoration and peace of mind.
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 w-full sm:w-auto">
          <Button size="lg" className="h-14 px-10 text-lg rounded-lg w-full sm:w-auto shadow-lg bg-primary text-primary-foreground hover:opacity-90 transition-opacity" asChild>
            <Link to="/ContactPage">
              <CalendarCheck className="mr-2 w-6 h-6" />
              Book Your Session
            </Link>
          </Button>
          <Link to="/ContactPage" className="text-primary font-sans font-medium hover:underline underline-offset-4 transition-all">
            View Location
          </Link>
        </div>
      </div>
    </section>;
}